module.exports = __webpack_public_path__ + "img/page.bf6ef030.png";